"use client";

import { SenseiMarkLoader } from "@/shared/components/layout/SenseiMarkLoader";

interface GeneratingModalProps {
  query: string;
}

export function GeneratingModal({ query }: GeneratingModalProps) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Generating diagnostic"
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 110,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        backdropFilter: "blur(8px)",
        animation: "fadeIn .2s ease",
      }}
    >
      <div
        style={{
          background: "var(--paper-2)",
          border: "1px solid var(--line-strong)",
          borderRadius: "20px",
          padding: "36px 32px 28px",
          maxWidth: "440px",
          width: "100%",
          textAlign: "center",
          boxShadow: "0 24px 60px rgba(0,0,0,0.35)",
          animation: "popIn .25s ease",
        }}
      >
        {/* Animated SENSEI logo */}
        <div className="diag-logo-wrap">
          <SenseiMarkLoader size={64} />
        </div>

        <h3 style={{ margin: "24px 0 8px", fontSize: "20px", fontWeight: 600, color: "var(--ink)" }}>
          Creating your diagnostic
        </h3>
        <p
          style={{
            margin: "0 auto 20px",
            color: "var(--ink-soft)",
            fontSize: "13.5px",
            lineHeight: 1.6,
            maxWidth: "300px",
          }}
        >
          SENSEI is analyzing your prompt and preparing a tailored assessment. This typically takes a few seconds.
        </p>

        {/* Query quote */}
        <div
          style={{
            background: "rgba(91,108,255,0.08)",
            border: "1px solid rgba(91,108,255,0.2)",
            borderRadius: "12px",
            padding: "12px 16px",
            fontSize: "13px",
            color: "var(--ink)",
            fontWeight: 500,
            fontStyle: "italic",
            textAlign: "left",
            display: "-webkit-box",
            WebkitLineClamp: 2,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
          }}
        >
          “{query}”
        </div>

        {/* Progress bar */}
        <div className="diag-progress-track" aria-hidden="true">
          <div className="diag-progress-fill" />
        </div>
        <p
          style={{
            margin: "10px 0 0",
            color: "var(--ink-mute)",
            fontSize: "12px",
            letterSpacing: "0.04em",
          }}
        >
          Redirecting you to the assessment…
        </p>
      </div>
    </div>
  );
}
